import { Barcode, BarcodePicker } from 'scandit-sdk';

const CONFIG = {
  css: {
    class: 'barcode-scanner',
  },
  scandit: {
    engineLocation: process.env.REACT_APP_SCANDIT_ENGINE_LOCATION,
    guistyle: BarcodePicker.GuiStyle.NONE,
    licenseKey: process.env.REACT_APP_SCANDIT_LICENSE_KEY,
    scanSettings: {
      codeDuplicateFilter: 1000,
      enabledSymbologies: [
        Barcode.Symbology.CODE128,
        Barcode.Symbology.CODE39,
        Barcode.Symbology.EAN13,
        Barcode.Symbology.EAN8,
        Barcode.Symbology.MICRO_QR,
        Barcode.Symbology.QR,
        Barcode.Symbology.UPCA,
        Barcode.Symbology.UPCE,
      ],
      gpuAccelerationEnabled: false,
      searchArea: { x: 0.25, y: 0.25, width: 0.5, height: 0.5 },
    },
    videoFit: BarcodePicker.ObjectFit.COVER,
    zoom: 0,
  },
};

export default CONFIG;
